import { render, staticRenderFns } from "./admin-quote-main.vue?vue&type=template&id=225c8b9a&"
import script from "./admin-quote-main.vue?vue&type=script&lang=js&"
export * from "./admin-quote-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports